import { generateDialogParams } from '@/lib/generic.utils'
import { DataService, ProviderService, PublisherService } from '@api/index'
import { get } from 'lodash'

const SERVICE = new PublisherService('publishers')

export default {
  getAll(context) {
    return new Promise((resolve, reject) => {
      return SERVICE.get()
        .then(response => {
          context.commit('updateAll', response.data.result)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getSingle(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.get(params)
        .then(response => {
          context.commit('updateSingle', response.data.result)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteConfirmation: function(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.getDeleteConfirmation(params)
        .then(response => {
          context.commit(
            'updateGlobalDialogContent',
            generateDialogParams(params.dialogUid, 'deleteSingle', response.data),
            { root: true }
          )
          context.commit('updateGlobalDialogVisibility', { uid: params.dialogUid, value: true }, { root: true })
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteSingle(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.delete(params)
        .then(response => {
          context.dispatch('getAll')
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getCreateFormData(context) {
    return new Promise((resolve, reject) => {
      return SERVICE.getCreateFormData()
        .then(response => {
          context.commit('updateOwners', response.data.result.owners)
          context.commit('updateAddressTypes', response.data.result.address_types)
          context.commit('updateMetaDataFields', response.data.result.meta_data_fields_by_category)
          resolve()
        })
        .catch(err => reject(err))
    })
  },
  create(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.create(params)
        .then(response => {
          if (!get(response.data, 'messages.errors')) {
            resolve(response.data.result)
          } else {
            reject(new Error('Error on submit'))
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getPublisherSubscriptions(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.getPublisherSubscriptions(params)
        .then(response => {
          context.commit('updateSubscriptions', response.data.result)
          resolve(response.data.result)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  update(context, params) {
    return SERVICE.update(params, 'patch')
      .then(response => response.data.result)
      .catch(err => err)
  },
  getMetaDataColumns({ commit }) {
    const SERVICE = new DataService('meta-data-columns/publisher')

    return new Promise((resolve, reject) => {
      return SERVICE.get()
        .then(response => {
          commit('updateMetaDataColumns', response.data.result)
          resolve(response.data.result)
        })
        .catch(err => reject(err))
    })
  },
  getSingleWithAddresses(context, params) {
    const SERVICE = new ProviderService('publishers')
    return SERVICE.getProviderAddresses(params)
      .then(response => response.data.result)
      .catch(err => new Error(err))
  }
}
